import { ModalAlert, ModalIcon, ShowModal } from "components/common-ui";
import { BusinessPage } from "core";
import InboxService, { Message } from "core/services/inbox.service";
import { useNavigate } from "react-router-dom";

const useInboxLogic = () => {
    const service = new InboxService();
    const navigate = useNavigate();

    const deleteMessageAsync = async (message: Message, onDelete: () => void) => {
        ShowModal({
            title: "Are you sure?",
            icon: ModalIcon.warning,
            body: "Do you want to delete this message?",
            buttonText: "Delete",
            showCancel: true,
            showClose: false,
            onClose: async () => {
                const response = await service.delete(message.category.id, message.id);

                if (response.data?.description?.includes("Error")) {
                    ModalAlert.error("Error deleting");
                    return;
                }

                onDelete();
            }
        });
    }

    const markAsReadAsync = async (message: Message) => {
        await service.markAsRead(message.category.id, message.id);
    }

    const viewMessage = async (message: Message) => {
        const url = BusinessPage.inboxMessage.replace(":id", message.id);
        navigate(url);
    }

    return {
        deleteMessageAsync,
        markAsReadAsync,
        viewMessage
    };
}

export default useInboxLogic;